export default "__VITE_ASSET__b68b1938__"